import * as React from 'react';
import { format } from 'date-fns';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import * as uuid from 'uuid/v4';

import { Row, Col } from 'react-flexbox-grid';
import { compose, withProps, withHandlers, mapProps } from 'recompose';

import * as storage from '@inqool/uas-web-core/es/utils/storage';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { InputField, Input, Date as DateInput, DateField } from '@components/form';
import { withNotifications } from '@components/hoc/withNotifications';
import { getUserProfile, putUserProfile } from '@modules/maps/_mapsActions';
import { getEmployee } from '@modules/employees/_employeesActions';

const enhance = compose<any, any>(
  withProps(() => {
    return { item: storage.get('id') };
  }),
  withNotifications({ putUserProfile }),
  entityDetailEnhancer<any, any>({
    getEntity: getEmployee,
    defaultEntity: {}
  }),
  mapProps(({ entity, ...rest }) => ({ employee: entity, ...rest })),
  entityDetailEnhancer<any, any>({
    getEntity: getUserProfile,
    defaultEntity: {}
  }),
  mapProps<{}, any>(({ entity, employee, ...rest }) => ({
    initialValues: {
      ...entity,
      employee
    },
    maxYear: format(new Date(), 'YYYY'),
    ...rest
  })),
  withHandlers({
    onSubmit: ({ closeItem, putUserProfileNotify }) => async formData => {
      const withId = formData.id ? formData : { ...formData, id: uuid() };
      const response = await putUserProfileNotify(withId);

      if (response) {
        closeItem();
      }
    }
  }),
  reduxForm({
    form: 'sps-form'
  })
);

const View: React.SFC<any> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Row>
        <Col md={12}>
          <h4>Přihlašovací údaje Spisová Služba</h4>
        </Col>
        <Col md={12}>
          <InputField component={Input} name="username" label="Uživatelské jméno" />
        </Col>
        <Col md={12}>
          <InputField component={Input} type={'password'} name="password" label="Heslo" />
        </Col>
        <Col md={12}>
          <InputField component={Input} name="certificateId" label="ID certifikátu" />
        </Col>
        <Col md={12}>
          <DateField
            component={DateInput}
            name={'validDatetime'}
            label={'Datum platnosti'}
            dateOnly={false}
            allowFuture={true}
          />
        </Col>
      </Row>
      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 ' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={props.closeItem} />
    </form>
  </div>
);

export const SpsModal = enhance(View);



// WEBPACK FOOTER //
// ./src/components/sidebar/userProfiles/SpsModal.tsx